(function($) {

    var tcVars = window.tc_vars || {};
    var isPageMyHistory = $('#my-history-lvp').length

    var toggleDeleteAll = function() {
        if (!isPageMyHistory) return;
        if ($('.lvp-product').length === 0) $('.delete-all-lvp').closest('.link-container').addClass('hidden');
        else $('.delete-all-lvp').closest('.link-container').removeClass('hidden');
    }

    // Execute only on MyHistory LVP
    if (isPageMyHistory) {

        toggleDeleteAll();

        var ajaxSwitchURL = "/" + tcVars.env_language + "/ajax/rest/model/atg/userprofiling/ProfileActor/setTrackLVP";
        var trackingSwitch = $('#browing-history');

        // Disable click on TOOLTIP
        $('#my-history-lvp .tooltip').on('click', function(e) { e.preventDefault(); });

        // Set default value for the SWITCH
        var isTrackingActive = $('#perso-lvp-grid').data('is-tracking');
        if (isTrackingActive) trackingSwitch.attr('checked', 'checked');
        else trackingSwitch.attr('checked', null);
        trackingSwitch.show();

        // Handle SWITCH CHANGE
        trackingSwitch.on('change', function() {
            var newState = $(this).is(':checked');
            // If newState is false > remove all LVP
            if (!newState) $('.delete-all-lvp').click();
            $.post( ajaxSwitchURL, {tracking: newState} )
                .done(function(data) { toggleDeleteAll(); })
                .fail(function(data) { });
        });
    }

    // Execute only when we can delete a LVP on a page
    var deleteLVP = $('.delete-lvp');

    if (deleteLVP.length) {
        var ajaxDeleteURL = "/" + tcVars.env_language + "/ajax/rest/model/atg/userprofiling/ProfileActor/deleteLVP";

        deleteLVP.on('click', function() {
        	var deleteAll = $(this).hasClass('delete-all-lvp') ? true : false;
            var $currentLVP = $(this).closest('.lvp-element');
            var sku = $currentLVP.data('sku-id');
            var ajaxParam = deleteAll ? "all" : sku + '';

            $.post( ajaxDeleteURL, {id: ajaxParam} )
                .done(function(data) {
                	if (deleteAll) {
                		$('.lvp-element').get().reverse().map(function(e, i) {
                			setTimeout(function() {
	                			var $e = $(e);
	                			$e.fadeOut(function() { $e.remove(); toggleDeleteAll(); });
                			}, i*100);
                		});
                	} else {
                    	$currentLVP.fadeOut(function() { $currentLVP.remove(); toggleDeleteAll(); });
                	}
            	})
                .fail(function(data) { });

        });
    }


})(jQuery);



// WEBPACK FOOTER //
// ./src/analytics/transcript-workaround/lvp-history.js